// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const WorkspaceConnectedItemTypeValues = [
	"CATALOG_PART",
	"CUSTOMER_ORDER",
	"PROJECT",
	"PRODUCT_CHANGE_REQUEST",
	"PRODUCT_CHANGE",
] as const;

export type WorkspaceConnectedItemType = (typeof WorkspaceConnectedItemTypeValues)[number];

export const getWorkspaceConnectedItemTypeLabels = () => ({
	CATALOG_PART: t("catalog_part"),
	CUSTOMER_ORDER: t("customer_order"),
	PROJECT: t("project"),
	PRODUCT_CHANGE_REQUEST: t("product_change_request"),
	PRODUCT_CHANGE: t("product_change"),
});

export const getWorkspaceConnectedItemTypeLabel = (value: WorkspaceConnectedItemType): string => {
	return getWorkspaceConnectedItemTypeLabels()[value];
};
